import axios from 'axios'
import create from 'zustand'
import { persist } from 'zustand/middleware'
import Cookies from 'js-cookie'

//#region user store
let store = (set) => ({
  // store users
  users: {},
  // get All users
  getUsers: async () => {
    // setting token
    let token = Cookies.get('token')

    // attach token to header
    // sort and order data by which column and how
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
      params: {
        sortBy: 'user.id',
        orderBy: 'desc',
      }
    }
    // setting url 
    // main url comes from .env file
    const apiResponse = await axios.get(`${process.env.REACT_APP_API}/user`, config)
    set(async (state) => {
      // initilize users state variable to the responsed users if request succeed
      if (apiResponse?.status == 200 || apiResponse?.status == 201)
        state.users = apiResponse.data
    })
  },
  addUser: async (payload) => {
    // setting token
    let token = Cookies.get('token')

    // attaching token to the header
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }

    // setting url 
    // main url comes from .env file 
    const apiResponse = await axios.post(`${process.env.REACT_APP_API}/user`, payload, config)
    if (apiResponse?.status === 201) {
      set(async (state) => {
        // initilizing users state variable to the resoponsed data
        state.users = {
          data: [apiResponse.data, ...state.users.data],
          limit: state.users.limit,
          page: state.users.page,
          totalCount: state.users.totalCount + 1,
        }
      })
    }
    return apiResponse
  },
  editUser: async (payload, id) => {
    // setting token
    let token = Cookies.get('token')

    // attaching token to the header
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }

    // setting url 
    // main url comes from .env file 
    const apiResponse = await axios.patch(`${process.env.REACT_APP_API}/user/${id}`, payload, config)
    // update users state variable if update request was succeed
    if (apiResponse?.status === 200) {
      set(async (state) => {
        const result = state.users?.data?.find((user, index) => {

          if (user.id === id) {
            state.users.data[index] = apiResponse?.data
          }
        })

        state.users = {
          data: [...state.users.data],
          limit: state.users.limit,
          page: state.users.page,
          totalCount: state.users.totalCount,
        }
      })
    }
    return apiResponse
  },
  deleteUser: async (id) => {
    // setting token
    let token = Cookies.get('token')

    // attaching token to the header
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }
    // setting url 
    // main url comes from .env file 
    const apiResponse = await axios.delete(`${process.env.REACT_APP_API}/user/${id}`, config)
    // delete element in the users.data array state if the request was succeed
    if (apiResponse?.status === 200) {

      set(async (state) => {
        const arr = state.users.data.filter(item => item.id !== id)
        state.users = {
          data: arr,
          limit: state.users.limit,
          page: state.users.page,
          totalCount: state.users.totalCount - 1,
        }
      })

    }

    return apiResponse

  },
})
//#endregion user store

// store the state in the browser local storage
// store = persist(store, { name: 'user' })

// getting store data in the browser localstorage
const user_Store = create(store)

export default user_Store
